import React from 'react'
import './Footer.css'

const Footer = () => (
    <div className="footer">
      <h6>All text and design is copyright © 2021 secfilingsearcher.com. All rights reserved.</h6>
    </div>
)
export default Footer
